import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";

import OtpVerificationForm from "@/Components/auth/forms/OtpVerificationForm";

import AuthText from "./Common/AuthText";
import { APP_ENV } from "../../Constants/common";
import { loadState } from "../../localStorage";
import { apiDecrypt } from "../../utilities/keyEncryption";

/**
 * Function for OTP verification.
 *
 * @param {object} user_id - the user ID
 * @param {string} email - the user's email
 * @param {string} APP_ENV - the application environment
 * @param {string} csrf_token - the CSRF token
 * @return {JSX.Element} the OTP verification component
 */
export default function OtpVerification(
  {
    //   user_id,
    //   email,
    //   APP_ENV,
    //   csrf_token,
  },
) {
  const { session } = useSelector((state) => state.session);
  const { id, email } = useParams();
  const savedState = loadState();
  const initialState = savedState;
  // if(initialState && initialState.session) {
  //   dispatch(setSession(initialState.session.session));
  // }
  const localSession = initialState?.session?.session;
  if (
    !(session?.user_id && session?.user_type && session?.user_token) &&
    !(
      localSession?.user_id &&
      localSession?.user_type &&
      localSession?.user_token
    )
  ) {
    return <Navigate to="/login" />;
  }
  // console.log("id", id, "email", email);
  return (
    <div className="font-openSans">
      <input type="hidden" name="new_user_id" id="new_user_id" />
      <input type="hidden" name="new_user_type" id="new_user_type" />
      <div className="flex justify-between gap-3 max-md:flex-col">
        <div className="">
          {/* verify otp  */}
          <div className={`flex w-full flex-col gap-6 font-medium`}>
            <OtpVerificationForm
              user_id={id}
              APP_ENV={APP_ENV}
              email={apiDecrypt(email)}
            />
            {/* <LoginRightTop
            text={"Don’t have an account?"}
            href={null}
            onClick={null}
            linkText={"Sign Up"}
            /> */}
          </div>
          {/* verify otp  */}
        </div>
        <AuthText />
      </div>
    </div>
  );
}
